import React, { useState, useEffect } from 'react';

const RSSFeedPopup = ({ onClose, onSave, media }) => {
    const [name, setName] = useState('');
    const [url, setUrl] = useState('');
    const [maxItems, setMaxItems] = useState(5);
    const [duration, setDuration] = useState(10);

    useEffect(() => {
        if (media) {
            setName(media.name);
            setUrl(media.text);
            setMaxItems(media.maxItems || 5);
            setDuration(media.duration || 10);
        }
    }, [media]);

    const handleSave = () => {
        if (!url || !name) return alert('Name and URL are required');
        onSave({ name, url, maxItems, duration });
    };

    return (
        <div className="popup-overlay">
            <div className="popup-content">
                <h2>{media ? 'Edit RSS Feed' : 'Add RSS Feed'}</h2>
                <div className="form-group">
                    <label>Name:</label>
                    <input type="text" className="form-control" value={name} onChange={(e) => setName(e.target.value)} />
                </div>
                <div className="form-group">
                    <label>RSS Feed URL:</label>
                    <input type="text" className="form-control" value={url} onChange={(e) => setUrl(e.target.value)} />
                </div>
                <div className="form-group">
                    <label>Max Items:</label>
                    <input type="number" className="form-control" value={maxItems} onChange={(e) => setMaxItems(parseInt(e.target.value))} />
                </div>
                <div className="form-group">
                    <label>Duration per Item (seconds):</label>
                    <input type="number" className="form-control" value={duration} onChange={(e) => setDuration(parseInt(e.target.value))} />
                </div>
                <div className="form-buttons">
                    <button className="btn btn-success" onClick={handleSave}>Save</button> &nbsp;
                    <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
                </div>
            </div>
        </div>
    );
};

export default RSSFeedPopup;
